import { CSSProperties } from "react";
import styled from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface DemoTagProps {
  isShort?: boolean;
  isSmall?: boolean;
  style?: CSSProperties;
}

const DemoTag = ({ isShort, isSmall, style }: DemoTagProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  return (
    <Tag style={style} $isSmall={isSmall}>
      {isShort
        ? t("demo_mode.workspace_demo_short")
        : t("demo_mode.workspace_demo_full")}
    </Tag>
  );
};

export default DemoTag;

export const Tag = styled.div<{ $isSmall?: boolean }>`
  background: ${(p) =>
    `linear-gradient(114.66deg, ${p.theme.colors.demoTagColors})`};
  border-radius: 50px;
  text-transform: uppercase;
  color: ${(p) => p.theme.colors.layoutBgColor};
  font-weight: ${(p) => p.theme.typography.fontWeights.BOLD};
  padding: 4px 10px;
  width: fit-content;
  white-space: nowrap;
  ${(p) =>
    p.theme.isNewLook &&
    `
    background: ${p.theme.colors.lightBlue};
    color: ${p.theme.colors.primaryBlue};
    text-transform: none;
    font-size: ${p.theme.typography.fontSizes.S};
    letter-spacing: 0;
    padding: 3px 10px;
  `}
  ${(p) =>
    p.$isSmall &&
    `
   font-size: ${p.theme.typography.fontSizes.S};
   padding: 2px 8px;

  `};
`;
